import { EVENT_TYPES } from "constants/appointments";

/**
 * What a dragged event is called in classic's move confirmation (ENG-2313): "Clinic Event",
 * "Personal Event", "Work Shift"… from `EVENT_TYPES`, the same words the form uses. A kind
 * it does not know stays "Appointment", the wording every drag used before.
 */
export const moveEventLabel = (type?: string | null) =>
  EVENT_TYPES.getFromCode(type) || "Appointment";

export const moveEventTitle = (type?: string | null) =>
  `Are you sure you want to move this ${moveEventLabel(type).toLowerCase()}?`;
